export default function Checkbox({
  disabled,
  isChecked = false,
  isSmall = false,
  setIsChecked,
}) {
  return (
    <div
      className={`checkbox${
        disabled ? " disabled" : isChecked ? " selected" : ""
      }`}
      style={isSmall ? { height: 12, width: 12 } : null}
      onClick={() => (!disabled ? setIsChecked(!isChecked) : null)}>
      {
        <div className={`checkmark${isSmall ? " checkmark--small" : ""}`}>
          L
        </div>
      }
    </div>
  );
}
